<!--热点新闻类组件-->
<template>
    <div class="view5Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
        <div class="v5Items" v-for="(item,ix) in list" :key="`vi-5-${ix}`"
             @click="()=>onRouter(item.linkUrl,item.newsId)">
                <div class="imgBox"><img :src="require(`../../assets/img/${item.isChat?'chat':ix<3?'hot':'recom'}.png`)" alt="" class="imgView5"></div>
           {{item.name}}
    </div>
    </div>
</template>
<script>

    export default {
        name: "View5",
        components: {},
        props: {
            list: {
                type: Array,
                default: []
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {


            };

        },
        mounted() {

        },
        methods: {
            onRouter(path,id) {
                this.$emit('on-router',path,id,true)
            }
        }
    };
</script>
<style lang="less" scoped>
    .view5Wrapper {



        .v5Items {
            cursor: pointer;
            padding: .26rem 0;
            color: #4080FF;
            font-size: .35rem;
            max-width: 8rem;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            .imgBox{
                display: inline-block;
                vertical-align: top;
                width: .46rem;
                height: .46rem;
                margin-right: .1rem;
                .imgView5{
                    width: 100%;
                    height: 100%;
                }
            }
            span {
                color: #4080FF;
                font-size: .35rem;
            }


        }

    }

</style>
